import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import CustomDrawer from "@/shared/components/ui/Drawer/CustomDrawer";
import { X } from "lucide-react";
import React from "react";

const RelationshipDrawer = ({
  isOpen,
  onClose,
  drawerType,
  title,
  description,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  isPrimaryLoading = false,
  isPrimaryDisabled = false,
  isSecondaryDisabled = false,
  children,
}) => {
  return (
    <CustomDrawer
      isOpen={isOpen}
      onClose={onClose}
      direction={"right"}
      width={"562px"}
      height={"100%"}
      drawerClassName="rounded-none overflow-hidden"
      backdropClassName="z-[99999]"
      transitionDuration={400}
    >
      <div className="flex flex-col h-full min-h-0">
        <div className="flex-1 min-h-0 overflow-y-auto px-6 pt-12 pb-6 flex flex-col gap-8">
          <div className="flex items-start gap-2 w-full pr-4 pb-7 border-b border-gray-200 dark:border-gray-800">
            {/* title/description */}
            <div className="flex flex-col gap-1 w-[95%]">
              <h6 className="text-[1rem] font-semibold text-gray-800 dark:text-gray-100">
                {title}
              </h6>
              <p className="text-[0.75rem] text-gray-500 dark:text-gray-400 font-[Inter]">
                {description}
              </p>
            </div>

            {/* close button */}
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors"
            >
              <X
                size={16}
                className="cursor-pointer text-gray-800 dark:text-gray-200"
                strokeWidth={2}
              />
            </button>
          </div>
          {children}
        </div>

        {/* footer actions — pinned to drawer bottom */}
        <div className="flex-shrink-0 p-5 flex items-center w-full gap-8">
          <div className="w-[12%]">
            <SecondaryButton
              title={secondaryButtonText}
              onClick={onClose}
              className="w-full shadow-none border-none text-gray-400 dark:text-gray-300"
              size="sm"
              disabled={isSecondaryDisabled}
            />
          </div>
          <div className="w-[88%]">
            <PrimaryButton
              startContent={false}
              children={primaryButtonText}
              className="w-full shadow-none text-sm font-medium"
              size="md"
              onClick={onPrimaryClick}
              isLoading={isPrimaryLoading}
              disabled={isPrimaryDisabled}
            />
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default RelationshipDrawer;
